import { LogColors, LogSection } from './logger.types';
import { logUtils } from './logUtils';

const { pad, trim } = logUtils;

const SLOW_RESPONSE_THRESHOLD = 300;
const ERROR_RESPONSE_THRESHOLD = 400;

// Define the colors as a constant
const LOG_COLORS: LogColors = {
  info: '\x1b[0m', // white
  error: '\x1b[31m', // red
  warn: '\x1b[33m', // yellow
  slow: '\x1b[35m', // magenta
  reset: '\x1b[0m',
};

// Helper function for formatting values
const formatValue = (value: any): string => {
  if (value === undefined) return 'undefined';
  if (value === null) return 'null';

  if (typeof value === 'number') {
    if (value < 1 && value > 0) {
      return `${(value * 1000).toFixed(2)}ms`;
    }
    return String(value);
  }

  return trim(String(value), 60);
};

// Export an object instead of a class
export const LogFormatter = {
  formatSection({
    title,
    fields,
    color = LOG_COLORS.reset,
  }: LogSection): string {
    // Создаем заголовок с заданным названием и цветом
    const header = `${color}=== ${title} ===${LOG_COLORS.reset}`;

    // Переводим объекты в стоки
    const formattedFields = Object.entries(fields)
      // Убираем undefined значения
      .filter(([_, value]) => value !== undefined)
      // Преобразуем каждое поле в форматированную строку
      .map(([key, value]) => {
        // Дополняем ключ пробелами для выравнивания
        const formattedKey = pad(key + ':', 20);
        const formattedValue = formatValue(value);
        return `  ${formattedKey} ${formattedValue}`;
      })
      // Объединяем все строки полей с переносом строки
      .join('\n');

    return `${header}\n${formattedFields}`;
  },

  getTimeColor(time: number): string {
    return time > ERROR_RESPONSE_THRESHOLD
      ? LOG_COLORS.error
      : time > SLOW_RESPONSE_THRESHOLD
      ? LOG_COLORS.slow
      : LOG_COLORS.info;
  },

  get colors(): LogColors {
    return LOG_COLORS;
  },
};
